/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  DisplayRef,
  DisplayRef$inboundSchema,
  DisplayRef$Outbound,
  DisplayRef$outboundSchema,
} from "./displayref.js";

/**
 * Metric and setting refs used to render a compressor's Energy AI stage state.
 */
export type CompressorEnergyAIRefs = {
  /**
   * The compressor row name used by the sequencer table.
   */
  compressorName: string;
  /**
   * The compressor device alias.
   */
  deviceAlias: string;
  /**
   * A reading or setting reference that is used to display a value.
   */
  rampDownTimeSecs?: DisplayRef | undefined;
  /**
   * A reading or setting reference that is used to display a value.
   */
  rampDownTimerSecs?: DisplayRef | undefined;
  /**
   * A reading or setting reference that is used to display a value.
   */
  rampUpTimeSecs?: DisplayRef | undefined;
  /**
   * A reading or setting reference that is used to display a value.
   */
  runTimeSecs?: DisplayRef | undefined;
};

/** @internal */
export const CompressorEnergyAIRefs$inboundSchema: z.ZodType<
  CompressorEnergyAIRefs,
  z.ZodTypeDef,
  unknown
> = z.object({
  compressor_name: types.string(),
  device_alias: types.string(),
  ramp_down_time_secs: types.optional(DisplayRef$inboundSchema),
  ramp_down_timer_secs: types.optional(DisplayRef$inboundSchema),
  ramp_up_time_secs: types.optional(DisplayRef$inboundSchema),
  run_time_secs: types.optional(DisplayRef$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "compressor_name": "compressorName",
    "device_alias": "deviceAlias",
    "ramp_down_time_secs": "rampDownTimeSecs",
    "ramp_down_timer_secs": "rampDownTimerSecs",
    "ramp_up_time_secs": "rampUpTimeSecs",
    "run_time_secs": "runTimeSecs",
  });
});
/** @internal */
export type CompressorEnergyAIRefs$Outbound = {
  compressor_name: string;
  device_alias: string;
  ramp_down_time_secs?: DisplayRef$Outbound | undefined;
  ramp_down_timer_secs?: DisplayRef$Outbound | undefined;
  ramp_up_time_secs?: DisplayRef$Outbound | undefined;
  run_time_secs?: DisplayRef$Outbound | undefined;
};

/** @internal */
export const CompressorEnergyAIRefs$outboundSchema: z.ZodType<
  CompressorEnergyAIRefs$Outbound,
  z.ZodTypeDef,
  CompressorEnergyAIRefs
> = z.object({
  compressorName: z.string(),
  deviceAlias: z.string(),
  rampDownTimeSecs: DisplayRef$outboundSchema.optional(),
  rampDownTimerSecs: DisplayRef$outboundSchema.optional(),
  rampUpTimeSecs: DisplayRef$outboundSchema.optional(),
  runTimeSecs: DisplayRef$outboundSchema.optional(),
}).transform((v) => {
  return remap$(v, {
    compressorName: "compressor_name",
    deviceAlias: "device_alias",
    rampDownTimeSecs: "ramp_down_time_secs",
    rampDownTimerSecs: "ramp_down_timer_secs",
    rampUpTimeSecs: "ramp_up_time_secs",
    runTimeSecs: "run_time_secs",
  });
});

export function compressorEnergyAIRefsToJSON(
  compressorEnergyAIRefs: CompressorEnergyAIRefs,
): string {
  return JSON.stringify(
    CompressorEnergyAIRefs$outboundSchema.parse(compressorEnergyAIRefs),
  );
}
export function compressorEnergyAIRefsFromJSON(
  jsonString: string,
): SafeParseResult<CompressorEnergyAIRefs, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CompressorEnergyAIRefs$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CompressorEnergyAIRefs' from JSON`,
  );
}
